<!--
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
-->
<template>
  <div
    class="landing-page signin kiosk-mode"
    :class="{
      'join': !onSettingsPage,
      'settings': onSettingsPage,
      'popup': roomPinPopup
    }"
  >
    <div class="side-2">
      <!-- Popup window room pin -->
      <div
        v-if="roomPinPopup"
        key="password-reset-popup"
        class="popup-container"
      >
        <div
          class="card easy-card-white reset-password"
          @click.stop
        >
          <form-button
            class="back"
            :text="$t('APP_TEXT_BACK')"
            icon="SvgArrowDown"
            data-qa="back_button"
            link
            @onClick="hideRoomPinPopup"
          />
          <div class="card-body">
            <div class="row mt-3">
              <div class="col">
                <h5>{{ $t('APP_TEXT_ROOM_PIN_HEADING') }}</h5>
                <h6>{{ $t('APP_TEXT_ROOM_PIN_INFO') }}</h6>
              </div>
            </div>
            <div class="row justify-content-center text-left">
              <form-input
                ref="roomPinTextBox"
                v-model="roomPin"
                type="text"
                data-qa="room_pin_text_box"
                righticon="SvgCloseStroke"
                :placeholder="$t('APP_TEXT_ENTER_YOUR_PIN')"
                @rightIconClick="clearRoomPin"
              />
            </div>
            <div class="row justify-content-center mt-4">
              <div class="col">
                <form-button
                  v-if="verifyingRoomPin"
                  type="primary"
                  class="float-right"
                  icon="SvgLoading"
                  :text="$t('APP_TEXT_DONE')"
                />
                <form-button
                  v-else
                  type="primary"
                  data-qa="reset_button"
                  class="float-right"
                  :text="$t('APP_TEXT_DONE')"
                  @onClick="gotoMeeting"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Header section start -->
      <div class="header">
        <div class="row top-nav">
          <div class="col-4 v-align btn-container" />
          <div class="col-4 v-align center logo-container">
            <img
              :src="$_LOGOS.BRAND_LOGO_DEFAULT_LIGHT"
              alt
            >
          </div>
          <div class="col-4 v-align search-container" />
        </div>
      </div>
      <!-- Content section start -->
      <div
        class="content row"
      >
        <div class="col signin-container p-0">
          <div class="card easy-card-white">
            <div class="card-body">
              <!-- Back Button -->
              <form-button
                v-if="isDesktopApp || onSettingsPage"
                :text="onSettingsPage ? $t('APP_TEXT_BACK') : $t('APP_TEXT_CANCEL')"
                class="back"
                icon="SvgArrowDown"
                link
                @onClick="onGoBack"
              />
              <form class="join-box">
                <div class="row">
                  <div class="col">
                    <h4 class="heading">
                      {{ $t('KIOSK_TEXT_JOIN_TITLE') }}
                    </h4>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <form-input
                      v-if="!room"
                      v-model="roomNumber"
                      type="text"
                      :label="{text:$t('APP_TEXT_ROOM')}"
                      lefticon="SvgUser"
                      righticon="SvgCloseStroke"
                      :placeholder="$t('APP_TEXT_ENTER_THE_ROOM')"
                      @rightIconClick="clearRoom"
                    />
                    <form-input
                      v-model="displayName"
                      type="text"
                      :label="{text:$t('KIOSK_TEXT_ENTER_YOUR_NAME')}"
                      lefticon="SvgUser"
                      righticon="SvgCloseStroke"
                      :placeholder="$t('KIOSK_TEXT_NAME')"
                      @rightIconClick="clearDisplayName"
                    />
                    <div class="form-group mb-0 mt-5 pt-4 text-center">
                      <form-button
                        class="btn-secondary"
                        :text="$t('KIOSK_TEXT_CONNECT')"
                        @onClick="gotoMeeting"
                      />
                    </div>
                  </div>
                </div>
              </form>
              <MeetingSubmitForm
                ref="meetingSubmitForm"
                :action="$_CONFIG.appconfig.EM_MEETING_URL"
                :bandwidth="bandwidth"
                :exiturl="urlToExit"
                :room="roomNumber"
                :dname="displayName"
                :pin="roomPin"
                :kiosk="true"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- Footer section start -->
      <div
        class="footer row"
      >
        <div
          v-if="!isDesktopApp"
          class="col text-center terms"
        >
          <!-- eslint-disable-next-line vue/no-v-html -->
          <span v-html="$t('KIOSK_TEXT_TERMS_STATEMENT')" /> &nbsp;
          <a @click="openTermsOfService">{{ $t('APP_TEXT_TERMS_OF_SERVICE') }}</a>
        </div>
        <div class="col col-5 text-right language-container">
          <div
            v-if="languages"
            class="btn btn-link"
          >
            <svg-icon icon="SvgGlobe" />
            {{ language }}
            <select
              v-model="language"
              @change="languageChange"
            >
              <option
                v-for="(option,index) in languages"
                :key="`language_land_${index}`"
                :value="option.key"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import kiosk from '@/app/kiosk';
import MeetingSubmitForm from '@/components/MeetingSubmitForm';
export default {
  name: 'Kiosk',
  components: {
    MeetingSubmitForm
  },
  extends: kiosk
};
</script>
